import { createFetchListApi } from './client';

export type StrapiMedia = {
    id?: number;
    documentId?: string;
    url?: string;
    alternativeText?: string;
    caption?: string | null;
    name?: string;
};

export type DashboardBlogArticle = {
    id: number;
    documentId?: string;
    title?: string;
    slug?: string;
    description?: string;
    publishedAt?: string;
    createdAt?: string;
    updatedAt?: string;
    cover?: StrapiMedia;
};

export const blogApi = createFetchListApi({
    baseUrl: import.meta.env.STRAPI_URL,
    token: import.meta.env.STRAPI_API_TOKEN,
});
